'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findResponderByIdFromList = findResponderByIdFromList;
function findResponderByIdFromList(_ref) {
  var responders = _ref.responders,
      responderId = _ref.responderId;

  return responders.find(function (responder) {
    return responder.userId === responderId;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/responders/operators/findResponderByIdFromList.js
// module id = 813
// module chunks = 2 3